import GetCookies from 'hooks/GetCookies';
import moment from 'moment';

export const getSessionValue = () => {
  const sessionData = GetCookies('Token');
  if (sessionData) {
    return true;
  } else {
    return false;
  }
};

export const formatDateWithDay = date => {
  return moment.utc(date).format('dddd, Do MMMM YYYY');
};

export const checkDateBetweenNovemberToDecember = bookingDate => {
  if (!bookingDate) return false;

  const targetDate = new Date(bookingDate);
  const year = targetDate.getFullYear();

  const startOfNovember = new Date(year, 10, 1); // 1 Nov (month index 10)
  const endOfDecember = new Date(year, 11, 31, 23, 59, 59, 999); // 31 Dec end of day

  return targetDate >= startOfNovember && targetDate <= endOfDecember;
};

export const fromBase64 = str => decodeURIComponent(escape(atob(str)));

export const toBase64 = str => btoa(unescape(encodeURIComponent(str)));
